<div class="center">

  <!-- THREAD HEADER -->
  <div class="thread-header">
    <div class="av">{{ initials }}</div>
    <div class="meta">
      <div class="name">{{ contact?.firstName }} {{ contact?.lastName }}</div>
      <div class="sub">{{ contact?.emailAddress }}<span *ngIf="contact?.mobileNum"> · {{ contact?.mobileNum }}</span></div>
    </div>
    <div class="header-flags">
      <span *ngFor="let lbl of contact?.labels" class="lbl" [ngClass]="getLabelClass(lbl)">● {{ lbl }}</span>
      <button class="lbl lbl-add" [class.flagged]="isFlagged" title="Toggle flag" (click)="toggleFlag()">{{ isFlagged ? '🚩 Flagged' : '＋ Flag' }}</button>
    </div>
  </div>

  <!-- THREAD ACTIONS -->
  <div class="thread-actions">
    <button class="primary" (click)="openReply()">↩ Reply</button>
    <button (click)="archiveThread()" title="Archive conversation">🗄 Archive</button>
    <button (click)="openAddTaskDialog()">+ Add Task</button>
    <button (click)="openNotePanel()">📝 Add Note</button>
    <div style="position:relative;display:inline-block;">
      <button (click)="showLabelMenu = !showLabelMenu">🏷 Apply Label ▾</button>
      <div *ngIf="showLabelMenu" style="position:absolute;top:100%;left:0;background:#fff;border:1px solid #ddd;border-radius:6px;box-shadow:0 4px 12px rgba(0,0,0,.12);z-index:100;min-width:160px;padding:4px 0;">
        <button *ngFor="let lbl of availableLabels" (click)="labelToggled.emit(lbl); showLabelMenu=false"
          style="display:block;width:100%;text-align:left;padding:6px 12px;background:none;border:none;cursor:pointer;font-size:13px;">
          {{ lbl }}
        </button>
      </div>
    </div>
    <button (click)="sendToBizDev()" title="Forward to BizDev inbox">📤 Send to BizDev</button>
    <button (click)="openTapeChart()" title="Open Tape Chart">📅 Tape Chart</button>
    <button class="ai-btn" (click)="summarize()" [disabled]="summarizing || !conversationId">
      {{ summarizing ? 'Summarizing…' : 'Summarize' }}
    </button>
    <div style="position:relative;display:inline-block;margin-left:auto;">
      <button class="overflow-btn" (click)="toggleOverflowMenu()" title="More actions">⋯</button>
      <div *ngIf="showOverflowMenu" style="position:absolute;top:100%;right:0;background:#fff;border:1px solid #ddd;border-radius:6px;box-shadow:0 4px 12px rgba(0,0,0,.12);z-index:100;min-width:180px;padding:4px 0;">
        <button (click)="overflowMarkUnread()" style="display:block;width:100%;text-align:left;padding:6px 14px;background:none;border:none;cursor:pointer;font-size:13px;">Mark as Unread</button>
        <button (click)="overflowMoveToStarred()" style="display:block;width:100%;text-align:left;padding:6px 14px;background:none;border:none;cursor:pointer;font-size:13px;">⭐ Move to Starred</button>
        <button (click)="overflowDelete()" style="display:block;width:100%;text-align:left;padding:6px 14px;background:none;border:none;cursor:pointer;font-size:13px;color:#c0392b;">🗑 Delete</button>
      </div>
    </div>
  </div>

  <!-- ARCHIVE SUCCESS/ERROR BANNER -->
  <div class="task-success-banner" *ngIf="archiveSuccess">
    Conversation archived.
    <button class="ai-summary-close" (click)="archiveSuccess = false">×</button>
  </div>
  <div class="task-success-banner" style="background:#fde8e8;color:#c0392b;" *ngIf="archiveError">
    {{ archiveError }}
    <button class="ai-summary-close" (click)="archiveError = ''">×</button>
  </div>

  <!-- ADD TASK SUCCESS BANNER -->
  <div class="task-success-banner" *ngIf="addTaskSuccess">
    Task created successfully.
    <button class="ai-summary-close" (click)="addTaskSuccess = false">×</button>
  </div>

  <!-- NOTE ERROR BANNER (L3) -->
  <div class="task-success-banner" style="background:#fde8e8;color:#c0392b;" *ngIf="noteError">
    {{ noteError }}
    <button class="ai-summary-close" (click)="noteError = ''">×</button>
  </div>

  <!-- BIZ DEV SUCCESS/ERROR BANNER (L4) -->
  <div class="task-success-banner" *ngIf="bizDevSuccess">
    Conversation forwarded to BizDev.
    <button class="ai-summary-close" (click)="bizDevSuccess = false">×</button>
  </div>
  <div class="task-success-banner" style="background:#fde8e8;color:#c0392b;" *ngIf="bizDevError">
    {{ bizDevError }}
    <button class="ai-summary-close" (click)="bizDevError = ''">×</button>
  </div>

  <!-- DELETE ERROR BANNER (L4) -->
  <div class="task-success-banner" style="background:#fde8e8;color:#c0392b;" *ngIf="deleteError">
    {{ deleteError }}
    <button class="ai-summary-close" (click)="deleteError = ''">×</button>
  </div>

  <!-- AI SUMMARY PANEL -->
  <div class="ai-summary" *ngIf="summary || summaryError">
    <div class="ai-summary-label">AI Summary</div>
    <div *ngIf="summary" class="ai-summary-text">{{ summary }}</div>
    <div *ngIf="summaryError" class="ai-summary-error">{{ summaryError }}</div>
    <button class="ai-summary-close" (click)="summary = ''; summaryError = ''">×</button>
  </div>

  <!-- ADD NOTE PANEL -->
  <div class="note-panel" *ngIf="addingNote">
    <textarea [(ngModel)]="noteBody" placeholder="Add an internal note…" rows="3" style="width:100%;box-sizing:border-box;padding:8px;border:1px solid #ccc;border-radius:4px;font-size:13px;resize:vertical;"></textarea>
    <div style="display:flex;gap:8px;margin-top:6px;">
      <button class="primary" (click)="submitNote()">Post Note</button>
      <button (click)="closeNotePanel()">Cancel</button>
    </div>
  </div>

  <!-- MESSAGES -->
  <div class="messages">
    <!-- Skeleton loader (replaces spinner while thread loads) -->
    <div *ngIf="loading" class="ums-skeleton-container">
      <!-- row 1: inbound, two lines -->
      <div class="ums-skeleton-msg ums-skeleton-msg--inbound">
        <div class="ums-skeleton-line ums-skeleton-line--short"></div>
        <div class="ums-skeleton-line ums-skeleton-line--long"></div>
      </div>
      <!-- row 2: outbound, one line -->
      <div class="ums-skeleton-msg ums-skeleton-msg--outbound">
        <div class="ums-skeleton-line ums-skeleton-line--medium"></div>
      </div>
      <!-- row 3: inbound, three lines -->
      <div class="ums-skeleton-msg ums-skeleton-msg--inbound">
        <div class="ums-skeleton-line ums-skeleton-line--long"></div>
        <div class="ums-skeleton-line ums-skeleton-line--medium"></div>
        <div class="ums-skeleton-line ums-skeleton-line--short"></div>
      </div>
      <!-- row 4: outbound, two lines -->
      <div class="ums-skeleton-msg ums-skeleton-msg--outbound">
        <div class="ums-skeleton-line ums-skeleton-line--medium"></div>
        <div class="ums-skeleton-line ums-skeleton-line--short"></div>
      </div>
      <!-- row 5: inbound, one line -->
      <div class="ums-skeleton-msg ums-skeleton-msg--inbound">
        <div class="ums-skeleton-line ums-skeleton-line--long"></div>
      </div>
    </div>

    <!-- Error state -->
    <div *ngIf="!loading && loadError" class="thread-error">{{ loadError }}</div>

    <div class="thread-col" *ngIf="!loading">
      <ng-container *ngFor="let group of messageGroups">
        <!-- Date divider -->
        <div class="date-divider" *ngIf="group.dateLabel">
          <span class="date-divider-label">{{ group.dateLabel }}</span>
        </div>
        <ng-container *ngFor="let msg of group.messages">
          <app-unified-bubble [msg]="msg"></app-unified-bubble>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <!-- COMPOSER -->
  <app-note-composer #composerEl
    [conversationId]="conversationId"
    [context]="context"
    [toEmail]="contact?.emailAddress"
    [toMobile]="contact?.mobileNum"
    [lastMsgId]="messages.length ? messages[messages.length-1].msgId : null"
    (messageSent)="onMessageSent()">
  </app-note-composer>

</div>
